import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import DashboardEconomic from './dashboard/DashboardEconomic';
import DashboardEnvironmental from './dashboard/DashboardEnvironmental';
import DashboardReachAwareness from './dashboard/DashboardReachAwareness';
import DashboardReachedPopulation from './dashboard/DashboardReachedPopulation';
import DashboardSustainabilityLegacy from './dashboard/DashboardSustainabilityLegacy';

import { formatSeparateByThousands } from 'Helpers/formatService';

import Button from 'CommonComponents/Button';

export default function EventImpactDashboard(props) {
    const [request, setRequest] = useState(false);
    const [data, setData] = useState({});

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        setRequest(true);
        axios
            .get(props.fetchUrl)
            .then((response) => {
                setData(response.data.data);
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {
                setRequest(false);
            });
    };

    const formatAndRound = (val) => {
        return isNaN(parseFloat(val)) ? `${val}` : formatSeparateByThousands(Math.round(val));
    };

    const generateReport = () => {
        axios
            .post(window.generateUrl, data)
            .then((response) => {
                window.location.href = window.archiveUrl;
            })
            .catch((e) => {
                console.log(e);
            });
    };

    return (
        <div>
            <div className="row mb-3">
                <div className="col">
                    <div className="float-right">
                        <Button variant="primary" id="report-generate-submit" onClick={generateReport}>
                            <span id="loading" className="spinner-border text-xs mr-1" style={{ width: '14px', height: '14px', display: 'none' }} role="status">
                                <span className="sr-only">{$t('Loading')}...</span>
                            </span>
                            {$t('Generate Report')}
                        </Button>
                    </div>
                </div>
            </div>

            <div className={'row'}>
                <div className={'col'}>
                    {!!data.economic && !!data.workforce && <DashboardEconomic data={data.economic} workforceData={data.workforce} format={formatAndRound} />}
                </div>
            </div>
            <div className={'row mt-3'}>
                <div className={'col'}>{data.reach_awareness && <DashboardReachAwareness data={data.reach_awareness} format={formatAndRound} />}</div>
            </div>

            <div className={'row mt-3'}>
                <div className={'col'}>
                    {data.reach_awareness && <DashboardReachedPopulation totalSocialReach={data.reach_awareness.total_social_reach} format={formatAndRound} />}
                </div>
            </div>

            <div className={'row mt-3'}>
                <div className={'col'}>{data.environmental && <DashboardEnvironmental data={data.environmental} format={formatAndRound} />}</div>
            </div>

            <div className={'row mt-3'}>
                <div className={'col'}>
                    {data.sustainability_legacy && <DashboardSustainabilityLegacy data={data.sustainability_legacy} format={formatAndRound} />}
                </div>
            </div>
        </div>
    );
}

if (document.getElementById('EventImpactDashboard')) {
    const rootEl = document.getElementById('EventImpactDashboard');
    ReactDOM.render(
        <App>
            <EventImpactDashboard fetchUrl={dashboardFetchUrl} />
        </App>,
        rootEl,
    );
}
